import { 
    Component
    , Input
    , OnInit
    , OnChanges
    , SimpleChanges
    , HostListener
    , ViewChildren
    , ElementRef
    , QueryList 
,  } from "@angular/core";

@Component({
    selector: 'accordion',
    templateUrl: './accordion.template.html',
    styleUrls: ['./accordion.style.scss']
})

export class Accordion implements OnInit{
    private el: ElementRef;
    @Input() item : any;
    @Input() showDate : boolean = false;
    @ViewChildren('arrow') arrows : QueryList<ElementRef>;

    @HostListener('click', ['$event'] ) onClick(e){

        if(!e.target.closest(".row") || !e.target.closest(".plus-minus")){
            return
        }
        var index = e.target.closest(".row").dataset.index;
        
        if ( !index ){return;}

        var target = this.el.nativeElement.querySelector("[data-index='" +  index + "']");
        
        if ( !target.classList.contains("collapsed")){
            target.classList.add("collapsed");
        }else{
            target.classList.remove("collapsed");
        }
    }
    
    constructor(el : ElementRef){
        this.el = el;
    }

    ngOnInit(){}
}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/list/accordion/accordion.component.ts